import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import * as db  from './database.js';

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		status: '',
		token: localStorage.getItem('token') || '',
  		user : {}
	},
	mutations: {
		auth_request(state){
	    	state.status = 'loading'
	  	},
	  	auth_success(state, token, user){

			state.status = 'success'
		    state.token = token
		    state.user = user
	  	},
	  	auth_error(state){
	    	state.status = 'error'
	  	},
	  	logout(state){
	    	state.status = ''
	    	state.db = ''
	    	state.token = ''
	  	},
	},
	actions: {
	  	login({commit}, params){
	        return new Promise((resolve, reject) => {
	            commit('auth_request')

				db.getAuth(params.enterprise,params.user,params.password)
				.then(result => {
					console.log(result.data)
					if (result.data.err!="")
					{
					resolve (result);
					//console.log (result.data.err);
					}
					else{
						const token = result.data.token
						const user = result.data.user
						//const codusuario = result.data.codusuario
						//const codusucursal = result.data.codusucursal

						localStorage.setItem('token', token)

						// Add the following line:
						axios.defaults.headers.common['Authorization'] = token
						commit('auth_success', token, user)
						resolve(result)
						}
					}, error => {
						console.error(error);
				});

	        })
		},

		logout({commit}){
		    return new Promise((resolve, reject) => {
		      	commit('logout')
				  localStorage.removeItem('token')
				  localStorage.removeItem('codusuario')
				  localStorage.removeItem('codusucursal')

		      	//delete axios.defaults.headers.common['Authorization']
		      	resolve()
		    })
	  	}
	},
	getters : {
	  isLoggedIn: state => !!state.token,
	  authStatus: state => state.status,
	}
})
